import { Content } from '@sandbox/api-sdk';
import { AxiosRequestConfig } from 'axios';

export const SANDBOX_INFO_POLL_TIMEOUT = 10 * 3 * 1000;

export interface GetRawPayload {
  path: string;
  responseType: AxiosRequestConfig['responseType'];
}

export interface SandboxConfig {
  token: string;
  poolName: string;
  isProd?: boolean;
  storage_id?: string;
}

export enum TokenCode {
  Succeed = 0, // 成功
  Retreated = 805303 // 回档
}

export enum Type {
  jupyter = 'jupyter',
  normal = 'normal'
}

export enum PoolName {
  jupyter = 'app-jupyter',
  normal = 'pc-normal'
}

export enum FileLoadState {
  pending = 'pending',
  fulfilled = 'fulfilled',
  rejected = 'rejected'
}

export interface File extends Content {
  loadState: FileLoadState;
  downloadUrl: string;
  size: number;
  isDeleted: boolean;
  isSelected: boolean;
  isFromPrelude: boolean;
  isUpdated?: boolean;
}

export enum Exts {
  jpg = 'jpg',
  jpeg = 'jpeg',
  png = 'png',
  gif = 'gif',
  csv = 'csv',
  xls = 'xls',
  xlsx = 'xlsx',
  zip = 'zip',
  doc = 'doc',
  docx = 'docx',
  pdf = 'pdf',
  txt = 'txt',
  woff = 'woff',
  woff2 = 'woff2',
  xml = 'xml',
  mp3 = 'mp3',
  js = 'js',
  htm = 'htm',
  html = 'html',
  css = 'css',
  py = 'py'
}

export enum MimeTypes {
  jpg = 'image/jpeg',
  jpeg = 'image/jpeg',
  png = 'image/png',
  gif = 'image/gif',
  csv = 'text/plain',
  xls = 'application/vnd.ms-excel',
  xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  zip = 'application/zip',
  doc = 'application/msword',
  docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf = 'application/pdf',
  txt = 'text/plain',
  woff = 'font/woff',
  woff2 = 'font/woff2',
  xml = 'text/xml',
  mp3 = 'audio/mpeg',
  js = 'text/javascript',
  htm = 'text/html',
  html = 'text/html',
  css = 'text/css',
  py = 'text/x-python'
}
